import { SupportEmailButton } from "./support-email";
import { usePathname } from "next/navigation";
import { useTranslations } from "next-intl";

interface SupportButtonErrorProps {
  errorMessage?: string;
}

export function SupportButtonError({ errorMessage }: SupportButtonErrorProps) {
  const pathname = usePathname();
  const t = useTranslations("SupportError");

  return (
    <SupportEmailButton
      subject={t("subject")}
      body={t("body", {
        pathname,
        errorMessage: errorMessage || t("noErrorMessage"),
      })}
      plain
    >
      {t("buttonText")} <span aria-hidden="true">&rarr;</span>
    </SupportEmailButton>
  );
}
